import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CreditMemoParameter, getCreditMemo, SurCreditMemoModel } from "@tSurya/Services/CreditMemoService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<CreditMemoParameter, SurCreditMemoModel>;

export const DispatchBeginCreditMemo: HandlerType = props => {
    props.dispatch({
        type: "Custom/CreditMemoData/BeginLoadCreditMemo",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const StoreAPIParameterData: HandlerType = props => {
    if (!props.parameter) {
        return;
    }
    props.dispatch({
        type: "Custom/CreditMemoStore/CompletedLoadCreditMemoStore",
        searchparameter: props.apiParameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCreditMemo(props.apiParameter);
};

export const DispatchCompleteCreditMemo: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/CreditMemo/CompletedLoadCreditMemo",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginCreditMemo,
    PopulateApiParameter,
    StoreAPIParameterData,
    RequestDataFromApi,
    DispatchCompleteCreditMemo,
];

const loadCreditData = createHandlerChainRunner(chain, "LoadCreditData");
export default loadCreditData;
